import axios from "utils/axios";

export const getStageFieldsBySubStageId = async (subStageId) => {
  const response = await axios.get(`/api/StageField/GetStageFieldsBySubStageId/${subStageId}`);
  return response.data;
};

export const upsertStageField = async (field) => {
  const response = await axios.post("/api/StageField/UpsertStageField", field);
  return response.data;
};

export const deleteStageField = async (stageFieldId) => {
  const response = await axios.post(`/api/StageField/DeleteStageField/${stageFieldId}`);
  return response.data;
};

export const getStageFieldOptions = async (stageFieldId) => {
  const response = await axios.get(`/api/StageField/GetStageFieldOptions/${stageFieldId}`);
  return response.data;
};

export const upsertStageFieldOption = async (option) => {
  const response = await axios.post("/api/StageField/UpsertStageFieldOption", option);
  return response.data;
};

export const deleteStageFieldOption = async (stageFieldOptionId, stageFieldId) => {
  const response = await axios.post(`/api/StageField/DeleteStageFieldOption/${stageFieldOptionId}/${stageFieldId}`);
  return response.data;
};

export const getLeadFieldValues = async (leadId) => {
  const response = await axios.get(`/api/Leads/${leadId}/FieldValues`);
  return response.data;
};
